import React, { useState, useEffect } from "react";
import styles from "./styles/DriverItem.module.css";

function timeStringToSeconds(timeStr) {
  if (timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds.toFixed(3); // Rounds to three decimal places
  }
  return ""; // Handle the case when timeStr is not provided
}

export default function DriverItem({
  key,
  position,
  number,
  first_name,
  last_name,
  last_lap_time,
  difference,
  best_lap,
  best_time,
  lap,
}) {
  const [positionChange, setPositionChange] = useState(false);
  useEffect(() => {
    setPositionChange(true);
    setTimeout(() => {
      setPositionChange(false);
    }, 800);
  }, [lap]);
  return (
    <div key={key} className={positionChange ? styles.DriverItemChange : styles.DriverItem}>
      <div className={styles.Position}>{position}</div>
      <div className={styles.Competitor}>
        <p className={styles.Number}># {number}</p>
        <p> {first_name} {last_name}</p>
      </div>
      <div className={styles.Laps}>{lap}</div>
      <div className={styles.Difference}>{difference}</div>
      <div className={styles.LastLap}>{timeStringToSeconds(last_lap_time)} </div>
      <div className={styles.BestTime}>{timeStringToSeconds(best_time)}</div>
      <div className={styles.BestLap}>{best_lap}</div>
    </div>
  );
}
